export default __webpack_public_path__ + "static/media/whatbgp.bdbdee42.png";